import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kpi-card" }
const _hoisted_2 = { class: "kpi-header" }
const _hoisted_3 = { class: "kpi-title" }
const _hoisted_4 = {
  key: 0,
  class: "kpi-footer"
}
const _hoisted_5 = { class: "text-muted small" }


export default {
  __name: 'KpiCard',
  props: {
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  iconColorClass: {
    type: String,
    default: 'text-muted',
  },
  hint: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */),
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass([__props.icon, 'kpi-icon', __props.iconColorClass])
            }, null, 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["kpi-value", { 'compact-list': __props.compact }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    (_ctx.$slots.footer || __props.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.hint), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}